export default "__VITE_ASSET__a9855f68__"